import { NgModule } from '@angular/core';

import { LoginPageRoutingModule } from './login-routing.module';

import { LoginPage } from './login.page';
import { SharedModule } from '@app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BuyTicketButtonComponent } from './buy-ticket-button/buy-ticket-button.component';
import { RegisterButtonComponent } from './register-button/register-button.component';

@NgModule({
  imports: [
    SharedModule,
    LoginPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [
    LoginPage, 
    BuyTicketButtonComponent,
    RegisterButtonComponent,
  ]
})
export class LoginPageModule {}
